export default "<router-outlet></router-outlet>\n\n<div class=\"main-panel\">\n\n        <footer-cmp></footer-cmp>\n    </div>\n"